import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import shallow from 'zustand/shallow'
import PerText from '../Text'
import PerFlexRow from '../FlexRow'
import PerButtonCircle from '../ButtonCircle'
import { TargetTemplateModalType } from './types'
import { useTargetTemplateModalStore } from './TargetTemplateModalStore'

export const TargetTemplateModalHeader: FC = () => {
  const { t } = useTranslation()

  const [closeTargetTemplateModal, cleanTargetTemplateModal, targetTemplateModalType] = useTargetTemplateModalStore(
    (state) => [state.closeTargetTemplateModal, state.cleanTargetTemplateModal, state.targetTemplateModalType],
    shallow,
  )

  const handleClose = () => {
    closeTargetTemplateModal()
    setTimeout(() => {
      cleanTargetTemplateModal()
    }, 300)
  }

  const renderHeader = () => {
    if (targetTemplateModalType === TargetTemplateModalType.editTarget) {
      return t('targetTemplateModal.editTarget')
    } else if (targetTemplateModalType === TargetTemplateModalType.newTarget) {
      return t('targetTemplateModal.newTarget')
    } else {
      return null
    }
  }

  return (
    <>
      <PerFlexRow justify="space-between" align="middle">
        <PerFlexRow>
          <PerText fontSize="xl" color="primary">
            {renderHeader()}
          </PerText>
        </PerFlexRow>
        <PerButtonCircle size="large" icon="close_stroke" color="transparent" onClick={handleClose} testid="tm-modal-close" />
      </PerFlexRow>
    </>
  )
}
